module.exports = __webpack_public_path__ + "static/media/BusseltonDunsborougTimes-devicecomp-min@2x.30ea011b.png";